export const enum NavItemType {
    PAGE = "PAGE",
    LINK = "LINK"
}